import { PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

import { SceneHeader } from './SceneHeader'
import { WidthWrap } from './WidthWrap'

type Breadcrumb = {
  label: string
  to?: string
}

export const SceneContainer = ({
  title,
  description,
  breadcrumbs,
  children,
}: PropsWithChildren<{
  title?: string
  description?: string
  breadcrumbs?: Breadcrumb[]
}>) => {
  return (
    <div>
      <SceneHeader />
      <main className="py-4">
        <WidthWrap>
          <div className="space-y-4">
            {!!breadcrumbs?.length && (
              <div className="mt-2 flex items-center space-x-2 text-sm text-gray-500">
                {breadcrumbs.map((crumb, index) => (
                  <div key={index} className="flex items-center">
                    {index > 0 && <span className="mx-2">/</span>}
                    {crumb.to ? (
                      <Link to={crumb.to} className="hover:text-gray-700">
                        {crumb.label}
                      </Link>
                    ) : (
                      <span>{crumb.label}</span>
                    )}
                  </div>
                ))}
              </div>
            )}

            {!!title && (
              <div className="flex items-center justify-between py-4">
                <div>
                  <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
                  {!!description && (
                    <p className="mt-1 text-sm text-gray-500">{description}</p>
                  )}
                </div>
              </div>
            )}

            {children}
          </div>
        </WidthWrap>
      </main>
    </div>
  )
}
